<template>
  <div>
    <div v-if="loading.admin" class="h-100 d-flex justify-center align-center">
      <v-progress-circular :size="50" color="primary" indeterminate/>
    </div>

    <BackBtn />
    <BreadCrumbs :items="breadcrumbs" />

    <ProfileTopPanel v-if="admin"
      userTypeName="Администратор"
      :name="admin.last_name + ' ' + admin.first_name"
      :city="admin.city"
      :phone="admin.phone"
      :email="admin.email"
      permssionEdit="edit_admin"
      permssionDelete="_delete_admin"
      whoDelete="администратора"
      @delete="onDelete()" @edit="onEdit()"
    />
<!--    <div class="row justify-end">-->
<!--      <div class="col-12 col-md-6">-->
<!--        <ProfileNavigationPanel-->
<!--          :header-text="'Мои услуги и тесты'"-->
<!--          :body-text="'В этом разделе отображаются все приобретённые вами услуги и тесты. Вы можете начать прохождение доступных тестов или открыть результаты уже завершённых.'"-->
<!--          :link="'/my-services'"-->
<!--          :show-link-anyway="true"-->
<!--          :linkWithoutApp="false"-->
<!--        />-->
<!--      </div>-->
<!--    </div>-->
    <div class="row">
      <div class="col-12 col-md-6">
        <ProfileCardExpansionCounter
          @add="dialogAddLicencesShow=true"
          :enableAdd="$store.getters['users/counters/getEndpoint']('admin') && ( $store.getters['auth/isAllowed']('add_stockamount_admin') || $store.getters['auth/isAllowed']('add_stockamount') )"
          :user="admin"
          :userType="'Admin'"
        />
      </div>
      <div class="col-12 col-md-6">
        <ProfileCardCalc/>
      </div>
    </div>
    <AddLicensesDialog v-model="dialogAddLicencesShow" :toId="+userId" toType='admin' @success="reload()" />
    <!-- <ManagerEditDialog /> -->
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import ProfileTopPanel from '@/components/common/ProfileTopPanel';
import AddLicensesDialog from '@/components/admins/AddLicensesDialog.vue';
import ProfileCardCalc from '@/components/admins/profile/ProfileCardCalc';
import ProfileCardExpansionCounter from '@/components/clients/profile/ProfileCardExpansionCounter.vue';

export default {
  name: 'ProfileAdmin',
  components: {
    // ProfileNavigationPanel,
    ProfileCardExpansionCounter,
    // ManagerEditDialog,
    AddLicensesDialog,
    ProfileTopPanel,
    // ClientProfileCardCounters,
    ProfileCardCalc
  },
  props: ['userId'],
  provide() {
    return {
      userType: 'Admin',
      userId: this.userId,
    };
  },
  data() {
    return {
      dialogAddLicencesShow: false,
    };
  },
  computed: {
    ...mapGetters({
      admin: 'users/admins/admin',
      loading: 'users/admins/loading'
    }),
    breadcrumbs() {
      if (!this.admin) return [];
      return this.isProfile ? [
        { title: 'Личный кабинет', url: '/' },
      ] : [
        { title: 'Администраторы', url: '/admins/' },
        { title: `${this.admin.last_name} ${this.admin.first_name}`, url: `/admins/${this.admin.id}` },
      ];
    },
  },
  methods: {
    ...mapActions({
      loadAdmin: 'users/admins/loadAdmin',
      // setDialogEditShow: 'users/admins/setDialogEditShow'
    }),
    ...mapMutations({
      // setEditedManager: 'users/managers/setEditedManager'
    }),
    onEdit() {
      // this.setEditedManager({ ...this.manager });
      // this.setDialogEditShow(true);
    },
    onDelete() {
    },
    reload() {
      this.loadAdmin(this.userId);
    }
  },
  created() {
    this.loadAdmin(this.userId);
  },
};
</script>

<style scoped lang="scss">
@import "src/assets/styles/variables";
</style>
